import React, { useEffect } from "react";
import { Router, Switch, Route } from "react-router-dom";
import PrivateRoute from "./Components/Shared/PrivateRoute/PrivateRoute";
import PropTypes from "prop-types";
import history from "./utilities/_history";
import { connect } from "react-redux";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import Navbar from "./Components/layout/Navbar";

import Reports from "./Components/Reports";
// import Dashboard from "./Components/Dashboard"
import NewDashboard from "./Components/NewDashboard";
import KAMDashboard from "./Components/KAMDashboard";
import KAMTransfers from "./Components/KAMTransfers";
//import Calls from "./Components/Calls";
import Outlets from "./Components/Outlets";
import KAMOutlets from "./Components/KAMOutlets";
import OutletsDetail from "./Components/Outlets/components/OutletsDetail";
import KAMOutletsDetail from "./Components/KAMOutlets/components/KAMOutletsDetail";
import KycTracking from "./Components/KycTracking";
import Details from "./Components/KycTracking/components/details";
import eKycTracking from "./Components/ekyc";
import Admin from "./Components/Admin";
import FSEManagment from "./Components/Admin/pages/FSEManagement/FSEManagement";
import KAMServicing from "./Components/KAMServicing";
import AdminUpload from "./Components/AdminUpload";
import PageNotFound from "./Components/PageNotFound";
import Leaderboard from "./Components/Leaderboard";
import LeaderboardProfile from "./Components/Leaderboard/pages/leaderboard-profile";
import HierarchyModule from "./Components/Hierarchy";
import RouteManagement from "./Components/RouteManagement";

import SignIn from "./Components/Auth/signIn";
import SignOut from "./Components/Auth/signOut";
import ExternalCampaign from "./Components/ExternalCampaign";
import "./style.scss";
import UserDetails from "./Components/Hierarchy/components/UserTable/components/UserDetails/UserDetails";
import { Collapse, Fade } from "@material-ui/core";
import RouteTransferRequest from "./Components/RouteManagement/page/RouteTransferRequest/routeTransferRequest";
import _checkRouteAvailibility from "./utilities/_checkRouteAvailability";
import FieldForce from "./Components/FieldForce";
import OnlineDashboard from "./Components/OnlineDashboard";
import LandingPage from "./Components/Landing/landing";
import ChangePassword from "./Components/Auth/changePassword";
import ResetLink from "./Components/Auth/resetLink";
import ErrorBoundary from "./utilities/ErrorBoundary";
import FaceMatching from "./Components/FaceMatching";
import Playground from "./Components/Playground";
import BackOfficeManagement from "./Components/Admin/pages/BackofficeManagement/BackOfficeManagement";
import NewReports from "./Components/NewReport";
import NewNavbar from "./Components/NewNavbar/newNavbar";
import RevampedDashboard from "./Components/RevampedDashboard";
import NewUpload from "./Components/NewUpload";
import NewCalls from "./Components/NewCalls";
import Authentication from "./Components/Authentication";
import ServiceReferral from "./Components/ServiceReferral";
import MerchantLoanRequests from "./Components/MerchantLoanRequests";
import InventoryManagement from "./Components/InventoryManagement";
import BankInclusionRequests from "./Components/BankInclusionRequests";
import UserList from "./Components/UserList";
import UserProfilePage from "./Components/UserProfile";
import KPILeaderboard from "./Components/KPIDashboard";
import KPIMetricConfiguration from "./Components/KPIMetricConfiguration";

/**
 * The main APP component that wraps the entire application
 *
 * @component
 */

const App = ({ token, portal, userType }) => {
  const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));

  const rootRoute = () => {
    if (portal === "dexter") {
      return RevampedDashboard; // NewDashboard;
    } else {
      if (
        userType === "trade_merketing" ||
        userType === "merchant_management"
      ) {
        return KAMServicing;
      } else {
        return KAMDashboard;
      }
    }
  };

  return (
    <Router history={history}>
      {
        <div className="App">
          {/* <Navbar /> */}

          {<NewNavbar />}
          <div className="main-app-route-container">
            <ErrorBoundary>
              {localStorage.getItem("scope") === "online" ? (
                <Switch>
                  <Route exact path="/" component={LandingPage} />
                  <Route exact path="/dashboard" component={rootRoute()} />

                  {/* <Route exact path="/servicing" component={KAMServicing}></Route> */}

                  <Route exact path="/reports" component={Reports}></Route>
                  <Route
                    exact
                    path="/new-reports"
                    component={NewReports}
                  ></Route>
                  <Route
                    exact
                    path="/online-dashboard"
                    component={OnlineDashboard}
                  ></Route>
                  <Route
                    exact
                    path="/outlets"
                    component={portal === "kam" ? KAMOutlets : Outlets}
                  ></Route>
                  <Route
                    exact
                    path={`/outlets/:id`}
                    component={
                      portal === "kam" ? KAMOutletsDetail : OutletsDetail
                    }
                  ></Route>
                  <Route exact path="/admin" component={Admin}></Route>
                  <Route
                    exact
                    path="/admin/fse/:id"
                    component={FSEManagment}
                  ></Route>

                  <Route
                    exact
                    path="/admin-upload"
                    component={AdminUpload}
                  ></Route>
                  <Route
                    exact
                    path="/new-uploads"
                    component={NewUpload}
                  ></Route>
                  <Route
                    exact
                    path="/my-profile"
                    component={UserProfilePage}
                  ></Route>
                  <Route
                    exact
                    path="/user-profile"
                    component={UserProfilePage}
                  ></Route>
                  {/* <Route exact path="/admin/h-module" component={HierarchyModule}></Route> */}

                  <Route path="/signout" component={SignOut}></Route>
                  {/* {<Route path="/signin" component={SignIn}></Route>} */}
                  <Route path="/signin" component={Authentication}></Route>

                  <Route path="*">
                    <PageNotFound />
                  </Route>
                </Switch>
              ) : (
                <Switch>
                  <Route exact path="/playground" component={Playground} />
                  <Route exact path="/dashboard" component={rootRoute()} />
                  <Route exact path="/" component={LandingPage} />

                  {/* <Route exact path="/servicing" component={KAMServicing}></Route> */}
                  <Route exact path="/calls" component={NewCalls}></Route>
                  <Route
                    exact
                    path="/merchant-loan-requests"
                    component={MerchantLoanRequests}
                  ></Route>
                  <Route
                    exact
                    path="/bank-inclusion-requests"
                    component={BankInclusionRequests}
                  ></Route>
                  <Route
                    exact
                    path="/inventory-management"
                    component={InventoryManagement}
                  ></Route>
                  <Route
                    exact
                    path="/transfers"
                    component={KAMTransfers}
                  ></Route>
                  <Route exact path="/reports" component={Reports}></Route>
                  <Route
                    exact
                    path="/new-reports"
                    component={NewReports}
                  ></Route>
                  <Route
                    exact
                    path="/new-uploads"
                    component={NewUpload}
                  ></Route>
                  {/* <Route
                    exact
                    path="/calls"
                    component={portal === "kam" ? KAMCalls : Calls}
                  ></Route> */}
                  <Route
                    exact
                    path="/outlets"
                    component={portal === "kam" ? KAMOutlets : Outlets}
                  ></Route>
                  <Route
                    exact
                    path={`/outlets/:id`}
                    component={
                      portal === "kam" ? KAMOutletsDetail : OutletsDetail
                    }
                  ></Route>
                  <Route exact path="/kyc" component={KycTracking}></Route>
                  <Route exact path="/ekyc" component={eKycTracking}></Route>
                  <PrivateRoute
                    exact
                    path="/face-matching"
                    component={FaceMatching}
                  ></PrivateRoute>
                  <Route
                    exact
                    path="/kyc/received/:action/:id/:kyc"
                    component={Details}
                  ></Route>
                  <Route
                    exact
                    path="/field-force"
                    component={FieldForce}
                  ></Route>
                  <Route
                    exact
                    path="/geo-management"
                    component={HierarchyModule}
                  ></Route>
                  <Route exact path="/admin" component={Admin}></Route>
                  <Route
                    exact
                    path="/admin/fse/:id"
                    component={FSEManagment}
                  ></Route>
                  <Route
                    exact
                    path="/admin/employee/:id"
                    component={BackOfficeManagement}
                  ></Route>
                  <Route exact path="/user/:id" component={UserDetails}></Route>
                  <Route
                    exact
                    path="/admin-upload"
                    component={AdminUpload}
                  ></Route>
                  <Route exact path="/users" component={UserList}></Route>
                  <Route
                    exact
                    path="/my-profile"
                    component={UserProfilePage}
                  ></Route>
                  <Route
                    exact
                    path="/user-profile"
                    component={UserProfilePage}
                  ></Route>
                  <Route
                    exact
                    path="/kpi-leaderboard"
                    component={KPILeaderboard}
                  ></Route>
                  <Route
                    exact
                    path="/kpi-metric-configuration"
                    component={KPIMetricConfiguration}
                  ></Route>
                  {/* <Route exact path="/admin/h-module" component={HierarchyModule}></Route> */}
                  {_checkRouteAvailibility("route-management") && (
                    <Route
                      exact
                      path="/route-management"
                      component={RouteManagement}
                    ></Route>
                  )}
                  {_checkRouteAvailibility("route-management") && (
                    <Route
                      exact
                      path="/route-management/transfer"
                      component={RouteTransferRequest}
                    ></Route>
                  )}
                  <Route path="/signout" component={SignOut}></Route>
                  {/* <Route path="/signin" component={SignIn}></Route> */}
                  <Route path="/signin" component={Authentication}></Route>
                  {!token && (
                    <Route path="/reset_password" component={ResetLink}></Route>
                  )}
                  <Route
                    exact
                    path="/leaderboard"
                    component={Leaderboard}
                  ></Route>
                  <Route
                    exact
                    path="/service-referral"
                    component={ServiceReferral}
                  ></Route>
                  <Route
                    exact
                    path="/leaderboard/:id"
                    component={LeaderboardProfile}
                  ></Route>
                  <Route exact path="/quiz" component={ExternalCampaign} />
                  <Route path="*">
                    <PageNotFound />
                  </Route>
                </Switch>
              )}
            </ErrorBoundary>
          </div>
        </div>
      }
    </Router>
  );
};

const mapStateToProps = ({ auth }) => ({
  token: auth.authToken ? auth.authToken : null,
  portal: auth.authToken ? auth.authToken.portal : null,
  userType: auth.authToken ? auth.authToken.type : null,
});

export default connect(mapStateToProps)(App);

App.propTypes = {
  token: PropTypes.object,
  portal: PropTypes.string,
  userType: PropTypes.string,
};
